import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unionDel",
  "use": "icon-unionDel-usage",
  "viewBox": "0 0 14.999 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.999 14\" id=\"icon-unionDel\">\r\n  <defs>\r\n    <style>\r\n      #icon-unionDel .cls-1 {\r\n        fill: #1890ff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-unionDel_联合_26\" data-name=\"联合 26\" class=\"cls-1\" d=\"M9713-1530h-11v-10h1.1v9h8.8v-9h1.1v10Zm-3-3v-6h1v6Zm-3,0v-6h1v6Zm-3,0v-6h1v6Zm-4-8v-1h15v1Zm4-2v-1h7v1Z\" transform=\"translate(-9700.001 1544.001)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol